import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core'
import { UserPersonalDetails } from '../../models/user-personal-details'
import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { UserTypeGateway } from '../../gateways/user-type-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { CommissionLevelGateway } from '../../gateways/commission-level-gateway'
import { OrgLevelGateway } from '../../../org-management/gateways/organization-gateway'
import { VwOrgLevelDetails } from '../../../org-management/models/view-orglevel-details'
import { OrgTreeView } from '../../../common/components/orgTreeView/orgTreeViewDropdown.Component'
import { UserDataService } from '../../gateways/common-data-service'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { CurrentUser } from '../../../common/models/current-user'

import { SettingGatewayGateway } from '../../../org-management/gateways/setting-gateway'

import { OrgSettingsModel } from '../../../org-management/models/org-settings-model'
import { EditFmoAbstractGateway } from '../../../org-management/gateways/edit-fmo-abstract-gateway'

import { Router, Params, ActivatedRoute } from '@angular/router'

import { PasswordTextFieldValidator } from '../../../validations/password-text-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { OrgBrowserView } from '../../../reports/models/org-browser-view'
import { OrganizationDataGateway } from '../../../reports/gatewasys/organization-data.gateway'
@Component({
    selector: 'UserPersonalDetails',
    templateUrl: 'user-personal-details-component.html',
    styleUrls: ['./user-personal-details-component.scss']
})
export class UserPersonalDetailsComponent extends Validatable<UserPersonalDetails> implements OnInit, AfterViewInit {
    // @Input() disabled = false
    @Output() onValueChange: EventEmitter<UserPersonalDetails> = new EventEmitter<UserPersonalDetails>()

    @Output() onAddPersonalDetails: EventEmitter<UserPersonalDetails> = new EventEmitter<UserPersonalDetails>()

    emailValidator = new EmailAddressTextFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(9)
    numericValidator = new NumericTextFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()
    @ViewChild('child') private child: OrgTreeView
    validatedDate = new DateTextFieldValidator()
    userPersonalDetails: UserPersonalDetails
    // userType: ValidatedSelectOptionModel[]
    org: ValidatedSelectOptionModel[]

    userprofileStatus: ValidatedSelectOptionModel[]
    @Input() statusReason: ValidatedSelectOptionModel[] | null = []
    selectedUserStatus: ValidatedSelectOptionModel[]
    bgChkResult: ValidatedSelectOptionModel[]
    // orgDetails: VwOrgLevelDetails

    @Input() currentUser: CurrentUser
    @Input() profileId: string
    @Input() controlMode: boolean
    @Input() pageTitle: string
    @Input() disabledBgChkResult: boolean
    @Input() BgChkResultDate: string
    @Input() isAddMode: boolean
    @Input() isBackGroundDisabled: boolean
    @Input() isStatusDisabled: boolean
    @Input() isAgentMode: boolean
    bgChkResultSelected: string
    @Input() selectedRoleID: number
    _userType: ValidatedSelectOptionModel[]
    @Input() set userType(value: ValidatedSelectOptionModel[]) {
        if (!this._userType) {
            this._userType = value
        }
    }
    @Input() disableLogIn: boolean
    @Input() displayEmpID: boolean
    @Input() noMiddleName: boolean = false
    @Output() validateEContract: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() userTypeSelection: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() userTypeSelectionEContract: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() setEmpIDValidation: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Input() BgChkStatus: number
    @Input() personalDetails: UserPersonalDetails
    passwordValidator = new PasswordTextFieldValidator()
    dispSSNDOB = false

    orgSelected: OrgBrowserView = new OrgBrowserView()
    isOrgSelectHidden: boolean = true

    constructor(
        formValidationService: FormValidationService,
        private userTypeGateway: UserTypeGateway,
        private comLevelGateway: CommissionLevelGateway,
        private orgLevelGateway: OrgLevelGateway,
        private settingGateway: SettingGatewayGateway,
        private router: Router,
        private route: ActivatedRoute,
        private editFmoGateway: EditFmoAbstractGateway,
        private userDataService: UserDataService,
        private userProfileGateway: UserProfileGateway,
        private orgDataGateway: OrganizationDataGateway
    ) {
        super(formValidationService)
        this.userPersonalDetails = {} as UserPersonalDetails

        // this.getUserTypes()
        //this.getOrganizations()
        this.getUserProfileStatus(false)
        this.getBackgroundCheckResult()

        this.disabledBgChkResult = false
        this.displayEmpID = false
        this.isAddMode = false
    }

    /*  getUserTypes() {
         this.userTypeGateway.getUserBasedRole().subscribe(
             (userTypemodel: ValidatedSelectOptionModel[]) => {
                 this.userType = userTypemodel
             })
     } */

    ngOnInit(): void {
        if (this.personalDetails.OrgID !== undefined) {
            // alert(this.personalDetails.OrgID)
            if (this.personalDetails.OrgID > 0) {
                this.OnOrgSelected(this.personalDetails.OrgID)
            }
        }
        if (this.controlMode === true) {
            this.noMiddleName = true
        }
    }

    ngAfterViewInit(): void {
        if (this.isAddMode || !this.isAgentMode) {
            this.isOrgSelectHidden = false
        }

        if (this.isAddMode) {
            //this.child.onDataLoad('None')
        } else {
            this.userDataService.data.subscribe((data: any) => {
                //this.child.onDataLoad(data)
                this.orgSelected.orgName = data

                //this.orgDataGateway.getOrganization(this.orgSelected.orgId).subscribe(
                //    (currentOrg) => {
                //        this.orgSelected = Object.assign({}, currentOrg)
                //    })
            })
        }
    }

    get PersonalDetails(): UserPersonalDetails {
        return this.userPersonalDetails
    }

    set PersonalDetails(value: UserPersonalDetails) {
        if (value) {
            this.userPersonalDetails = value
        }
    }

    getValue(): UserPersonalDetails {
        return this.userPersonalDetails
    }

    getLabel(): string {
        return ''
    }

    OnStatusChange(listID: number) {
        this.personalDetails.UserProfileStatusId = listID
        this.personalDetails.ProfileStatusDescription = ''
        this.statusReason = null
        this.selectedUserStatus = this.userprofileStatus.filter((x) => x.value === listID)
        if (this.selectedUserStatus !== undefined) {
            this.personalDetails.ProfileStatusDescription = this.selectedUserStatus[0].text
            this.getStatusReason(this.selectedUserStatus[0].text)
        }
    }

    getStatusReason(filter: string) {
        document.getElementById('divStatusreason')!.style.display = 'none'
        this.comLevelGateway.getAllCommissionLevel(filter).subscribe((statusReasonModel: ValidatedSelectOptionModel[]) => {
            this.statusReason = statusReasonModel

            if (statusReasonModel !== undefined || statusReasonModel !== null) {
                if (statusReasonModel.length > 0) {
                    document.getElementById('divStatusreason')!.style.display = 'block'
                }
            }
        })
    }

    OnUserTypeSelected(userTypeID: number) {
        let showEContract = true
        this.personalDetails.RoleID = userTypeID
        this.personalDetails.UserTypeDesc = ''
        this.dispSSNDOB = false
        this.personalDetails.UserTypeDesc = this._userType.filter((x) => x.value === userTypeID)[0].text
        if (
            this.personalDetails.UserTypeDesc === 'Super Admin SMM' ||
            this.personalDetails.UserTypeDesc === 'Super Admin SMA' ||
            this.personalDetails.UserTypeDesc === 'Super Admin' ||
            this.personalDetails.UserTypeDesc === 'Organization Manager' ||
            this.personalDetails.UserTypeDesc === 'eViewer' ||
            this.personalDetails.UserTypeDesc === 'Auditor'
        ) {
            this.userTypeSelectionEContract.emit(false)
        } else {
            this.userTypeSelectionEContract.emit(true)
        }
        if (this.personalDetails.UserTypeDesc === 'Agent: Marketing' || this.personalDetails.UserTypeDesc === 'Admin-Agent') {
            this.userTypeSelection.emit(true)
            if (this.personalDetails.BgApproved !== null && this.personalDetails.BgApproved !== undefined)
                if (
                    this.BgChkStatus === 0 &&
                    this.personalDetails.BgApproved.toString() === '1' &&
                    (this.personalDetails.SSN === undefined || this.personalDetails.SSN === null)
                )
                    this.dispSSNDOB = true
        } else {
            this.userTypeSelection.emit(false)
        }
    }

    getBackgroundCheckResult() {
        this.comLevelGateway.getAllCommissionLevel('BCResult').subscribe((bgChkResultModel: ValidatedSelectOptionModel[]) => {
            this.bgChkResult = bgChkResultModel
        })
    }

    getUserProfileStatus(retrieveAll: boolean) {
        this.userTypeGateway.getAllUserProfileStatus(false).subscribe((userProfileStatusModel: ValidatedSelectOptionModel[]) => {
            this.userprofileStatus = userProfileStatusModel
        })
    }

    onOrgSelectedFromView(org: any) {
        this.OnOrgSelected(org.orgId)
    }

    OnOrgSelected(orgID: number) {
        //document.getElementById('divEmpID').style.display = 'none'
        this.displayEmpID = false
        // orgID = 385
        this.personalDetails.OrgID = orgID
        this.setEmpIDValidation.emit(false)
        this.editFmoGateway
            .getOrgSettingValueBySettingName(orgID, 'FMO Settings', 'Marketing Channel')
            .subscribe((orgSettingModel: OrgSettingsModel[]) => {
                if (orgSettingModel !== null && orgSettingModel !== undefined) {
                    if (orgSettingModel.length == 1) {
                        if (orgSettingModel[0].SettingValue === 'Internal' || orgSettingModel[0].SettingValue === 'Internal-Group') {
                            this.displayEmpID = true
                            this.setEmpIDValidation.emit(true)
                            console.log('App Settings for Marketing Type :', orgSettingModel[0].SettingValue)
                        }
                    } else if (orgSettingModel.length > 1) {
                        this.displayEmpID = false
                    }
                }
            })

        this.userProfileGateway.getEcontractDetailsByOrgID(orgID).subscribe((data) => {
            this.validateEContract.emit(data)
        })
        //this.orgLevelGateway.getOrgDetailsByOrgID(orgID).subscribe(
        //    (orgDetailsModel: VwOrgLevelDetails) => {
        //        if (orgDetailsModel !== undefined || orgDetailsModel !== null) {
        //            if (orgDetailsModel.OrgEContract) {
        //                this.validateEContract.emit(true)

        //            } else {
        //                this.validateEContract.emit(false)
        //            }
        //        }

        //    })
    }

    getOrganizations() {
        this.userTypeGateway.getAllOrganization().subscribe((orgModel: ValidatedSelectOptionModel[]) => {
            this.org = orgModel
        })
    }

    changePwdNavigation() {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.isAgentMode) {
            this.router.navigate(['/' + insCo + '/user-management/update/' + this.personalDetails.UserProfileID])
        } else {
            this.router.navigate(['/' + insCo + '/user-management/reset/' + this.personalDetails.UserProfileID])
        }
    }
    middlenamecheck() {
        if (this.personalDetails.MiddleName !== undefined && this.personalDetails.MiddleName !== null && this.personalDetails.MiddleName !== '') {
            if (
                this.personalDetails.isNoMidNameChecked !== undefined &&
                this.personalDetails.isNoMidNameChecked !== null &&
                this.personalDetails.isNoMidNameChecked
            ) {
                this.personalDetails.isNoMidNameChecked = false
            }
        }
    }

    clickOnMiddleName() {
        if (
            this.personalDetails.isNoMidNameChecked !== undefined &&
            this.personalDetails.isNoMidNameChecked !== null &&
            this.personalDetails.isNoMidNameChecked
        ) {
            if (this.controlMode === false) {
                this.noMiddleName = false
            }
        } else {
            if (this.controlMode === false) {
                this.personalDetails.MiddleName = ''
                this.noMiddleName = true
            }
        }
    }

    OnBgCheckChanged(bgCheck: number) {
        this.dispSSNDOB = false
        this.personalDetails.BgApproved = bgCheck
        if (this.BgChkStatus === 0 && bgCheck.toString() === '1') {
            if (
                (this.personalDetails.UserTypeDesc === 'Agent: Marketing' || this.personalDetails.UserTypeDesc === 'Admin-Agent') &&
                (this.personalDetails.SSN === undefined || this.personalDetails.SSN === null)
            ) {
                this.dispSSNDOB = true
            }
        } else this.dispSSNDOB = false
    }
}
